// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZizAiqjB7KMrnE_X.ZizAiqjB7KMrnE_X {
	text-decoration: underline;
	color: var(--lok-color-text-default);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/StyledLink/StyledLink.module.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;CAC1B,oCAAoC;AACrC","sourcesContent":[".link.link {\n\ttext-decoration: underline;\n\tcolor: var(--lok-color-text-default);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `ZizAiqjB7KMrnE_X`
};
export default ___CSS_LOADER_EXPORT___;
